import { supabase } from './supabase';
import { toDashboardUiError } from './dashboard-errors';
import { ACCOUNT_TASK_COMPLETED_EVENT } from '@/components/activity/AccountCapabilityLauncher';
import type { ThreadTopicHorizon, ThreadTopicSummary } from '@shared/types/thread-work';
import type { WorkGuidanceMotif } from './work-guidance';

export type TopicPlan = ThreadTopicHorizon | 'dropped' | 'done';

/** J5: take on, plan or drop a Thread topic; the lists refresh afterwards. */
export const planTopic = async (params: {
  topicId: string;
  expectedTopicVersion: number;
  horizon: TopicPlan;
  plannedFor?: string | null;
  /** J6: why the work is set aside (dropped or done); kept as guidance. */
  motif?: WorkGuidanceMotif;
  note?: string | null;
}) => {
  const { error } = await supabase.functions.invoke('activity-feed', {
    body: {
      action: 'plan_topic',
      topicId: params.topicId,
      expectedTopicVersion: params.expectedTopicVersion,
      horizon: params.horizon,
      plannedFor: params.horizon === 'later' ? params.plannedFor ?? null : null,
      ...(params.motif ? { motif: params.motif, note: params.note ?? null } : {}),
    },
  });
  if (error) throw new Error((await toDashboardUiError(error, 'Le travail n’a pas pu être planifié.')).message);
  window.dispatchEvent(new CustomEvent(ACCOUNT_TASK_COMPLETED_EVENT));
};

/** Aujourd'hui: set aside the object actions of an app shown as one row, with one motive (one guidance note). */
export const setTopicsAside = async (params: {
  topics: Array<Pick<ThreadTopicSummary, 'id' | 'version'>>;
  horizon: 'dropped' | 'done';
  motif: WorkGuidanceMotif;
  note?: string | null;
  workTitle: string;
}) => {
  const { error } = await supabase.functions.invoke('activity-feed', {
    body: {
      action: 'set_topics_aside',
      topics: params.topics.map((topic) => ({ topicId: topic.id, expectedTopicVersion: topic.version })),
      horizon: params.horizon,
      motif: params.motif,
      note: params.note ?? null,
      workTitle: params.workTitle,
    },
  });
  if (error) throw new Error((await toDashboardUiError(error, 'Ces travaux n’ont pas pu être écartés.')).message);
  window.dispatchEvent(new CustomEvent(ACCOUNT_TASK_COMPLETED_EVENT));
};
